<template>
  <div>
    <ejs-button ref="stopTaskButton"
                iconCss="icon hero-icon h-spectrum-icon hero-icon-disable"
                cssClass="e-small e-round"
                :isPrimary="true" v-on:click.native="stopButtonClk" :disabled="stopButtonDisabled" class="h-spectrum-button" :title='stopTitle'>
    </ejs-button>
    <ejs-button ref="delTaskButton"
                iconCss="icon hero-icon h-spectrum-icon hero-icon-clear"
                cssClass="e-small e-round"
                :isPrimary="true" v-on:click.native="confirmBtnClick" :disabled="delButtonDisabled" :title='delTitle'>
    </ejs-button>
    <div class="control-section">
    <ejs-dialog :buttons='confirmDlgButtons' ref="confirmDialog" v-bind:visible="false" :header='confirmHeader' :animationSettings='animationSettings' :content='confirmContent' :showCloseIcon='confirmCloseIcon'
                :width='confirmWidth' :isModal='true'>
    </ejs-dialog>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
import i18n from '../../../plugins/i18n.js';
import { EventBus } from '../../../plugins/eventBus';

Vue.use(DialogPlugin);
enableRipple(true);
export default {
  name: 'SpectrumTaskOperButton',
  props: ['neId'],
  data() {
    return {
      // neId: '',
      stopTitle: this.$ts('Spectrum.ui_pt_spectrumstop'),
      delTitle: this.$ts('Spectrum.ui_pt_spectrumdelete'),
      cellid: '',
      stopButtonDisabled: false,
      delButtonDisabled: false,
      confirmHeader: this.$ts('Spectrum.ui_pt_spectrumdelete'),
      confirmContent: `<span>${this.$ts('Spectrum.ui_pt_spectrumdelconform')}</span>`,
      confirmCloseIcon: true,
      confirmWidth: '400px',
      animationSettings: { effect: 'None' },
      confirmDlgButtons: [{ click: this.confirmDlgBtnCancellClick, buttonModel: { content: this.$ts('Spectrum.ui_cancell') } }, { click: this.confirmDlgBtnOKClick, buttonModel: { content: this.$ts('Spectrum.ui_ok'), isPrimary: true } }]
  };
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    stopButtonClk() {
      const $this = this;
      const params = {
        neid: $this.$data.data.neid,
        id: $this.$data.data.id
      };
      const spectrum = {
        spectrum: params
      };
      // lte/ems/spectrum/stopSpectrumTask.html
      this.$axios.post('/lte/ems/spectrum/stopSpectrumTask.html', params).then((response) => {
        if (response && response.status === 200) {
          // this.changeIcon('stop');
          if (response.data.errorCode === 'SUCCESS') {
            this.stopButtonDisabled = true;
            this.delButtonDisabled = false;
            EventBus.$emit('toast', { type: 'success', content: this.$ts('Common.tips.success') });
            EventBus.$emit('spectrumTaskRefresh', 'stop');
          } else {
            // this.$layer.alert({ msg: this.$ts('Spectrum.6901') });
            if ("6900,6901,6902,6903,6906,6907,6908,6909,6910,6911,6912".includes(response.data.errorCode)) {
              EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          }
        }
      });
    },
    delButtonClk() {
      const $this = this;
      const params = {
        neid: $this.$data.data.neid,
        id: $this.$data.data.id
      };
      // lte/ems/spectrum/removeSpectrumTask.html
      this.$axios.post('/lte/ems/spectrum/removeSpectrumTask.html', params).then((response) => {
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.stopButtonDisabled = true;
            this.delButtonDisabled = true;
            EventBus.$emit('toast', { type: 'success', content: this.$ts('Common.tips.success') });
            EventBus.$emit('spectrumTaskRefresh', 'del');
          } else {
            // this.$layer.alert({ msg: this.$ts('Spectrum.6902') });
            // EventBus.$emit('toast', { type: 'warning', content: this.$ts('Spectrum.6902') });
            if ("6900,6901,6902,6903,6906,6907,6908,6909,6910,6911,6912".includes(response.data.errorCode)) {
              EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          }
        }
      });
    },
    confirmDlgBtnOKClick() {
      this.$refs.confirmDialog.hide();
      this.delButtonClk();
    },
    confirmDlgBtnCancellClick() {
      this.$refs.confirmDialog.hide();
    },
    confirmBtnClick() {
      this.$refs.confirmDialog.show();
    }
  }
};
</script>
<style>
</style>
